// rms-popup-ref.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class RmsPromptRef<T = any> {
  private readonly _closed = new Subject<T | undefined>();
  closed$ = this._closed.asObservable();

  close(data?: T) {
    this._closed.next(data);
    this._closed.complete();
  }
}
